import React from 'react'
import { connect } from 'react-redux'
import { List } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { getPlaylistTileStoreKey } from '../../../services/playlist/index'
import { isInHideWatched } from '../../../services/hide-watched/index'
import TileGridV2 from '../../TileGrid.v2/index'
import Sherpa from '../../Sherpa/index'
import LoadMore from '../../LoadMore/index'
import MultiplePlaylistsEmpty from '../MultiplePlaylistsEmpty/index'
import PlaylistEdit from '../../PlaylistEdit/index'
import { STORE_KEY_PLAYLIST_DEFAULT, STORE_KEY_PLAYLIST_FAVORITES, STORE_KEY_WATCH_HISTORY } from '../../../services/store-keys/index'

const getPlaylistUiLocation = (storeKey) => {
  switch (storeKey) {
    case STORE_KEY_WATCH_HISTORY:
      return 'Watch History'
    case STORE_KEY_PLAYLIST_FAVORITES:
      return 'Favorites'
    case STORE_KEY_PLAYLIST_DEFAULT:
      return 'Watch Later'
    default:
      return 'Custom Playlist'
  }
}

const renderTileGrid = (props, activePlaylistTiles, storeKey) => {
  const {
    playlist,
    setPlaylistQueueItem,
    addOrRemoveHideWatched,
    hideWatched,
  } = props
  let tileGridData
  const isWatchHistory = storeKey === STORE_KEY_WATCH_HISTORY
  const editMode = playlist.getIn(
    [storeKey, 'editMode'],
    false,
  )
  const uiLocation = getPlaylistUiLocation(storeKey)

  if (editMode) {
    tileGridData = activePlaylistTiles
      .getIn(['data', 'titles'])
      .map((item, index) => {
        const id = item.get('id')
        const title = item.get('title')
        const contentType = item.get('contentType')
        const seriesTitle = item.get('seriesTitle')
        const seriesId = item.get('seriesId')
        const inPlaylist = isWatchHistory
          ? !isInHideWatched(hideWatched.get('data'), id)
          : playlist.getIn(
            [storeKey, 'queue', index, 'playlist'],
            true,
          )
        const onClick = isWatchHistory
          ? () => addOrRemoveHideWatched({
            id,
            title,
            contentType,
            seriesId,
            seriesTitle,
          })
          : () => setPlaylistQueueItem(storeKey, index, id, !inPlaylist)

        const playlistEditComponent = (
          <PlaylistEdit
            onClick={onClick}
            inPlaylist={!inPlaylist}
          />
        )
        return item.set('playlistEditComponent', playlistEditComponent)
      })
  } else {
    tileGridData = activePlaylistTiles.getIn(['data', 'titles'])
  }

  return (
    <TileGridV2
      tileData={tileGridData}
      adminTitle={'Multiple Playlists'}
      reducedGrid
      uiLocation={uiLocation}
    />
  )
}

const MultiplePlaylistTiles = (props) => {
  const {
    getLoadMore,
    playlist,
    tiles,
  } = props
  const activePlaylistType = playlist.getIn(['userPlaylists', 'activePlaylist', 'type'], '')
  const tileStoreKey = getPlaylistTileStoreKey(activePlaylistType)
  const activePlaylistTiles = tiles.get(tileStoreKey)

  if (!activePlaylistTiles) return <Sherpa />

  const processing = activePlaylistTiles.get('processing')
  const placeholderTitlesExist = activePlaylistTiles.get('placeholderTitlesExist')
  const titlesCount = activePlaylistTiles.getIn(['data', 'titles'], List()).size
  const totalTilesCount = activePlaylistTiles.getIn(['data', 'totalCount'], 0)
  const playlistIsEmpty = totalTilesCount === 0 && !placeholderTitlesExist

  if (playlistIsEmpty) {
    return <MultiplePlaylistsEmpty playlistType={activePlaylistType} />
  }

  return (
    <React.Fragment>
      {renderTileGrid(props, activePlaylistTiles, tileStoreKey)}
      <LoadMore
        onLoadMore={getLoadMore}
        buttonClassName={['multiple-playlists__load-more-button', 'button--secondary']}
        currentCount={titlesCount}
        totalCount={totalTilesCount}
        processing={processing}
        infiniteScroll
      />
    </React.Fragment>
  )
}

export default connect(
  (state) => {
    return {
      auth: state.auth,
      resolver: state.resolver,
      hideWatched: state.hideWatched,
      playlist: state.playlist,
      tiles: state.tiles,
      user: state.user,
    }
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      getLoadMore: actions.playlist.getPlaylistTilesLoadMore,
      setPlaylistQueueItem: actions.playlist.setPlaylistQueueItem,
      addOrRemoveHideWatched: actions.hideWatched.addOrRemoveHideWatched,
    }
  },

)(MultiplePlaylistTiles)
